import React, { useEffect, useState } from "react";
import classes from "./ChallengeCountdown.module.css";
import CommonButton from "../../ui/CommonButton";
import axios from "axios";
import { env } from "../../constants/env";
import { useUser } from "../../context/UserContext";
import useWindowDimensions from "../../hooks/getWindowDimensions";

const ChallengeCountdown = ({ setShowPurchase, targetDate }) => {
  const [loading, setLoading] = useState(false);
  const { user } = useUser();

  const calculateTimeLeft = () => {
    const now = new Date();
    const difference = targetDate - now;

    if (difference <= 0) {
      return { days: 0, hours: 0, minutes: 0, totalMs: 0 };
    }

    const days = Math.floor(difference / (1000 * 60 * 60 * 24));
    const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((difference / (1000 * 60)) % 60);

    return { days, hours, minutes, totalMs: difference };
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
  const [slotData, setSlotData] = useState(null);

  const { height, width } = useWindowDimensions();

  const isMobile = width <= 768; // Mobile breakpoint

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000 * 60); // update every minute

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const fetchSlotData = async () => {
      try {
        const response = await axios.get(`${env.apiUrl}/api/user/slots`);
        setSlotData(response.data);
      } catch (err) {
        console.error("Failed to fetch slot data:", err);
      }
    };

    fetchSlotData();
  }, []);

  return (
    <div className={`${classes.wrapper}`}>
      <div
        className={`row flex-column flex-md-row align-items-center justify-content-between gap-4 ${classes.contentBox}`}
      >
        {/* Left Section */}
        <div className="col-12 col-md-5 text-center text-md-start px-0">
          {slotData?.availableSlots > 0 &&
          !user?.account?.synced &&
          timeLeft?.totalMs > 0 ? (
            <>
              <h3 className="text-white mb-2">
                Next Challenge Starts 17th September, 2pm PST
              </h3>

              {/* Available slots — hide on mobile */}
              {isMobile && (
                <div className={`${classes.slotsBox}`}>
                  <div>
                    <span>Available slots: </span>
                    {slotData && (
                      <span className={classes.slotsCount}>
                        {slotData.availableSlots}/{slotData.totalSlots}
                      </span>
                    )}
                  </div>
                </div>
              )}

              <div
                className={`${classes.slotsBox} d-flex align-items-center gap-2 flex-wrap justify-content-center justify-content-md-start`}
              >
                {/* Available slots — hide on mobile */}
                {!isMobile && (
                  <div>
                    <span>Available slots: </span>
                    {slotData && (
                      <span className={classes.slotsCount}>
                        {slotData.availableSlots}/{slotData.totalSlots}
                      </span>
                    )}
                  </div>
                )}

                {!isMobile && <div className={classes.divider} />}

                {/* 1-step plan */}
                <div>
                  <span>1-step plan: </span>
                  <span className={classes.slotsCount}>{slotData.oneStepRemaining}/{slotData.totalOneStep}</span>
                </div>
                <div className={classes.divider} />
                {/* 2-step plan */}
                <div>
                  <span>2-step plan: </span>
                  <span className={classes.slotsCount}>{slotData.twoStepRemaining}/{slotData.totalTwoStep}</span>
                </div>
              </div>
            </>
          ) : (
            <h3 className="text-white mb-2">
              All Spots Filled for September's Cohort
            </h3>
          )}
        </div>

        {/* Middle Countdown */}
        <div
          className={`col-12 col-md-4 d-flex justify-content-center ${classes.outerTimerBox}`}
        >
          <div className="d-flex justify-content-center gap-3">
            <div
              className={`${classes.timerWrapper} d-flex flex-column justify-content-center gap-2`}
            >
              <div className={classes.timerBox}>
                <span className={classes.timerValue}>{timeLeft.days}</span>
              </div>
              <span className={classes.timerLabel}>DAYS</span>
            </div>

            <div
              className={`${classes.timerWrapper} d-flex flex-column justify-content-center gap-2`}
            >
              <div className={classes.timerBox}>
                <span className={classes.timerValue}>{timeLeft.hours}</span>
              </div>
              <span className={classes.timerLabel}>HOURS</span>
            </div>

            <div
              className={`${classes.timerWrapper} d-flex flex-column justify-content-center gap-2`}
            >
              <div className={classes.timerBox}>
                <span className={classes.timerValue}>{timeLeft.minutes}</span>
              </div>
              <span className={classes.timerLabel}>MINUTES</span>
            </div>
          </div>
        </div>

        {/* Right CTA Button */}
        <div className="col-12 col-md-3 d-flex justify-content-center justify-content-md-end">
          <div className={classes.slotsDiscordButtonWrapper}>
            <CommonButton
              text={
                slotData?.availableSlots > 0 &&
                !user?.account?.synced &&
                timeLeft?.totalMs > 0
                  ? "Secure a spot"
                  : "Join Discord"
              }
              className={classes.buttonText}
              onClick={() => {
                if (
                  slotData?.availableSlots > 0 &&
                  !user?.account?.synced &&
                  timeLeft?.totalMs > 0
                ) {
                  setShowPurchase(true);
                } else {
                  window.open(
                    "https://discord.gg/8z37khrMA6",
                    "_blank",
                    "noopener,noreferrer"
                  );
                }
              }}
            />

            {slotData?.availableSlots > 0 &&
            !user?.account?.synced &&
            timeLeft?.totalMs > 0 ? null : (
              <p className={classes.spotsText}>
                To be first to know when new spots open
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChallengeCountdown;
